import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import { useAdvertiser } from "@redux/advertiser";
import { OutlinedInputRightAdornment } from "@assets/TextField";
import images from "@app/images";
import AdvertiserDialog from "@modals/AdvertiserDialog";
import AdvertiserInfoTable from "./AdvertiserInfoTable";
import { useMenuDispatch } from "@assets/contexts/MenuContext";

const CompAdvertiserInfo = () => {
  const value = useMenuDispatch(); // function  context
  const advertiser = useAdvertiser();
  const [open, setOpen] = useState(false);
  const [target, setTarget] = useState(null);
  const [infolist, setInfolist] = useState({
    rows: null,
    search: "",
    page: 1,
    loading: true,
    rows_default: null,
  });

  const handleOpenForm = (row) => {
    setTarget(row);
    setOpen(true);
  };
  const handleClose = () => setOpen(false);

  const handleChange = (event, value) => {
    setInfolist({
      ...infolist,
      page: value,
    });
  };

  const handleRowsUpdate = (target, email) => {
    const newRows = infolist.rows.map((row, index) => {
      if (row._id === target._id) {
        row.email = email;
      }
      return row;
    });
    setInfolist({
      ...infolist,
      rows: newRows,
    });
    setOpen(false);
  };

  const handleSearch = (e) => {
    const newText = e.target.value;
    if (e.target.value === "" || !e.target.value) {
      setInfolist({
        ...infolist,
        search: e.target.value,
        page: 1,
        rows: infolist.rows_default,
      });
    } else {
      setInfolist({
        ...infolist,
        search: newText,
        page: 1,
      });
    }
  };

  useEffect(() => {
    value({ type: "loadingStart" });
    advertiser.list((data, response) => {
      if (response.status === 200 && data.error === undefined) {
        setInfolist({
          ...infolist,
          loading: false,
          rows: data.result,
          rows_default: data.result,
        });
      } else {
      }
      value({ type: "loadingEnd" });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      {infolist.loading ? (
        <></>
      ) : (
        <>
          <Grid container justifyContent="flex-end">
            <Grid sx={{ width: 330, height: 50 }}>
              <OutlinedInputRightAdornment
                value={infolist.search}
                onChange={(e) => handleSearch(e)}
                sx={{ border: "1px solid #EEEEEF" }}
                name="adver_search"
                adorment={
                  <img
                    src={images.icn_active_search.default}
                    alt="search_icon"
                    width="24px"
                    height="24px"
                    style={{ marginTop: 6 }}
                  />
                }
              />
            </Grid>
          </Grid>
          <AdvertiserInfoTable
            onOpen={handleOpenForm}
            onChange={handleChange}
            infolist={infolist}
          />
        </>
      )}
      {open && (
        <AdvertiserDialog
          open={open}
          target={target}
          onClose={handleClose}
          onListUpdate={handleRowsUpdate}
        />
      )}
    </>
  );
};

export default CompAdvertiserInfo;
